const BASE_URL = process.env.REACT_APP_BASE_URL;

export const validateDocument = async (data, fileBlob, file, fileBlobOrigin, fileOrigin) => {
    const url = `${BASE_URL}/verifier/document?idpid=tsp`;

    const formData = new FormData();
    formData.append("extended_report", data.extended_report);
    formData.append("report_type", data.report_type);
    formData.append("verify_incremental_updates", data.verify_incremental_updates);
    formData.append("show_payload_json", data.show_payload_json);
    formData.append("emit_receipt", data.emit_receipt);
    formData.append('signature_files', fileBlob, file.name);
    if (null !== fileBlobOrigin) {
        formData.append('detached_files', fileBlobOrigin, fileOrigin.name);
    }
    const response = await fetch(url, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Failed to validate document');
    }

    return await response.json();
};